import { Component } from '@angular/core';

@Component({
  selector: 'bxbd-banner',
  template: `
        <div class="bannerContainer">
            <div class="bxbdLogo">
                <img src="/login/img/bxb-horizontal-rgb.png"
                    srcset="/login/img/bxb-horizontal-rgb@2x.png 2x,
                    /login/img/bxb-horizontal-rgb@3x.png 3x"
                    class="bxbdLogoImg">
            </div>
            <div class="bxbdText">
                <span class="text">Illuminate.</span>
                <span class="text">Reimagine.</span>
                <span class="text">Transform.<sup>TM</sup></span>
            </div>
        </div>`,
  styles: [require('./banner.component.scss')]
})
export class BannerComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/banner/banner.component.ts